<template>
	<div
		class="g-block-divider-center-diamond g-block-divider-padding"
		:class="{
			'g-block-divider-center-diamond--edit': editable,
			'is-active': editable && active,
			'g-block-divider-center-diamond--h5': h5,
			'g-block-divider-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-divider-center-diamond__wrap">
			<span
				class="g-block-divider-center-diamond__dots"
				:style="{ color: themeColor }"
				aria-hidden="true"
			></span>
			<span
				class="g-block-divider-center-diamond__diamond"
				:style="{ background: themeColor }"
				aria-hidden="true"
			></span>
		</div>
	</div>
</template>

<script>
	import { dividerMixin } from '../shared/dividerMixin.js';

	export default {
		name: 'GBlockDividerCenterDiamond',
		mixins: [dividerMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/dividerEditShell.less';
	@import '../shared/dividerPattern.less';

	.g-block-divider-center-diamond {
		.divider-block-edit-shell();
	}

	.g-block-divider-center-diamond__wrap {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.g-block-divider-center-diamond__dots {
		display: block;
		width: 100%;
		height: 2px;
		background: repeating-linear-gradient(
			to right,
			currentColor 0,
			currentColor 2px,
			transparent 2px,
			transparent 6px
		);
	}

	.g-block-divider-center-diamond__diamond {
		position: absolute;
		width: 6px;
		height: 6px;
		transform: rotate(45deg);
	}

	.g-block-divider-center-diamond--h5 {
		.g-block-divider-center-diamond__dots {
			height: 0.04rem;
			background: repeating-linear-gradient(
				to right,
				currentColor 0,
				currentColor 0.04rem,
				transparent 0.04rem,
				transparent 0.12rem
			);
		}

		.g-block-divider-center-diamond__diamond {
			width: 0.12rem;
			height: 0.12rem;
		}
	}
</style>
